import React, { useState, useEffect } from "react";
import WeatherIcon from "./WeatherIcon";
import "./Weather.css";

const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

const CONDITION_FAMILIES = {
    "clear sky": "clear",
    "few clouds": "clouds",
    "scattered clouds": "clouds",
    "broken clouds": "clouds",
    "overcast clouds": "clouds",
    "light rain": "rain",
    "moderate rain": "rain",
    "heavy intensity rain": "rain",
    "very heavy rain": "rain",
    "freezing rain": "rain",
    "shower rain": "rain",
    rain: "rain",
    "light snow": "snow",
    "heavy snow": "snow",
    snow: "snow",
    thunderstorm: "thunderstorm",
    mist: "mist",
    haze: "mist",
};

function conditionFamily(description) {
    return CONDITION_FAMILIES[description] || "default";
}

function Weather() {
    const [weatherData, setWeatherData] = useState(null);
    const [city, setCity] = useState("London");
    const [error, setError] = useState("");
    const [hasReading, setHasReading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const fetchWeather = (queryCity) => {
        setIsLoading(true);
        const url = `https://api.openweathermap.org/data/2.5/weather?q=${queryCity}&appid=${API_KEY}`;
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status === 404 ? "City not found" : "Weather service is not responding right now");
                }
                return response.json();
            })
            .then((data) => {
                setWeatherData(data);
                setError("");
                setHasReading(true);
            })
            .catch((fetchError) => {
                setWeatherData(null);
                setError(fetchError.message);
                setHasReading(false);
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        fetchWeather(city);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        fetchWeather(city);
    };

    const family = weatherData ? conditionFamily(weatherData.weather[0].description.toLowerCase()) : "default";

    return (
        <div className="station">
            <div className="station__panel">
                <span className="station__eyebrow">Local weather reading</span>

                <form className="station__form" onSubmit={handleSubmit}>
                    <label className="station__label" htmlFor="city-input">
                        City
                    </label>
                    <div className="station__input-row">
                        <input
                            id="city-input"
                            type="text"
                            value={city}
                            onChange={(event) => setCity(event.target.value)}
                            placeholder="Enter a city name"
                            className="station__input"
                        />
                        <button type="submit" className="station__submit">
                            Get weather
                        </button>
                    </div>
                </form>

                {error && <p className="station__error">{error}</p>}
                {isLoading && !error && <p className="station__loading">Reading station data...</p>}

                {hasReading && weatherData && (
                    <div className="station__reading">
                        <p className="station__place">{weatherData.name}</p>
                        <div className="station__primary">
                            <WeatherIcon family={family} />
                            <span className="station__temp">{(weatherData.main.temp - 273.15).toFixed(1)}°C</span>
                        </div>
                        <p className="station__condition">{weatherData.weather[0].description}</p>
                        <dl className="station__data">
                            <div className="station__data-row">
                                <dt>Wind</dt>
                                <dd>{(weatherData.wind.speed * 3.6).toFixed(1)} km/h</dd>
                            </div>
                            <div className="station__data-row">
                                <dt>Humidity</dt>
                                <dd>{weatherData.main.humidity}%</dd>
                            </div>
                        </dl>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Weather;
